import { useEffect } from 'react';
import { useUnsavedChanges } from '@/contexts/UnsavedChangesContext';

/**
 * Keeps the app-wide unsaved changes context in sync and warns on browser unload.
 * Returns the navigation confirmation helper.
 */
export const useUnsavedChangesGuard = (hasUnsavedChanges: boolean) => {
  const { setUnsavedChanges, confirmNavigation } = useUnsavedChanges();

  useEffect(() => {
    setUnsavedChanges(hasUnsavedChanges);
  }, [hasUnsavedChanges, setUnsavedChanges]);

  useEffect(() => {
    return () => setUnsavedChanges(false);
  }, [setUnsavedChanges]);

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      if (hasUnsavedChanges) { e.preventDefault(); e.returnValue = ''; }
    };
    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [hasUnsavedChanges]);

  return { confirmNavigation };
};
